import { FormControl } from '@angular/forms';
import { FlightBusinessPerson, FlightBusinessPersonType } from '@sd-portal/shared/models';
import { unbox } from 'ngrx-forms';

export class FlightBusinessPersonForm {
  flightBusinessPersonId: FormControl = new FormControl(0);
  flightBusinessPersonTypeId: FormControl = new FormControl(0);
  flightBusinessPersonTypeName: FormControl = new FormControl('');
  businessPerson: FormControl = new FormControl(null);
  businessPersonProfileId: FormControl = new FormControl(0);
  [key: string]: any; // eslint-disable-line @typescript-eslint/no-explicit-any

  constructor(flightBusinessPerson?: FlightBusinessPerson) {
    if (flightBusinessPerson) {
      this.flightBusinessPersonId.setValue(flightBusinessPerson.flightBusinessPersonId);
      this.flightBusinessPersonTypeId.setValue(flightBusinessPerson.flightBusinessPersonTypeId);
      let bpTypeName = '';
      if (flightBusinessPerson.flightBusinessPersonTypeId === FlightBusinessPersonType.REQUESTER) {
        bpTypeName = 'Requestor';
      } else if (
        flightBusinessPerson.flightBusinessPersonTypeId === FlightBusinessPersonType.PLANNER
      ) {
        bpTypeName = 'Planner';
      } else if (
        flightBusinessPerson.flightBusinessPersonTypeId === FlightBusinessPersonType.APPROVER
      ) {
        bpTypeName = 'Approver';
      }
      this.flightBusinessPersonTypeName.setValue(bpTypeName);
      this.businessPersonProfileId.setValue(
        unbox(flightBusinessPerson.businessPerson)?.businessPersonId
      );
      this.businessPerson = new FormControl(unbox(flightBusinessPerson.businessPerson));
    }
  }
}
